module.exports = __webpack_public_path__ + "img/8blue.5563c940.png";